var _path, _ellipse, _rect, _path2, _path3, _path4, _ellipse2, _ellipse3, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 151,
    viewBox: "0 0 170 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 54.9999C172.087 113.646 124.307 140 86.6366 140C48.9659 140 0 108.324 0 74.5869C0 40.85 8.99194 19.8416 46.8857 6.83252C84.7794 -6.17661 162.913 -3.64609 167.5 54.9999Z",
    fill: "#F5F5FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.75,
    cy: 41.25,
    rx: 3.75,
    ry: 3.75,
    fill: "#B1B0F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.25,
    y: 5.65479,
    width: 8.05617,
    height: 8.05617,
    rx: 1,
    transform: "rotate(-22.7167 88.25 5.65479)",
    fill: "#B1B0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.027 44.9125C135.479 45.9957 134.967 47.24 133.884 47.6918C127.175 50.4901 121.17 56.7757 116.455 64.7778C111.76 72.7463 108.481 82.1895 107.1 90.9442C106.917 92.1034 105.829 92.8949 104.669 92.712C103.51 92.5291 102.719 91.441 102.901 90.2818C104.363 81.0197 107.817 71.0665 112.793 62.6203C117.75 54.2079 124.357 47.0606 132.248 43.7693C133.331 43.3175 134.575 43.8293 135.027 44.9125Z",
    fill: "#E6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4534 9.16072C45.5745 9.0447 45.7761 9.12036 45.791 9.28743L46.23 14.222C46.2359 14.2891 46.2752 14.3487 46.3346 14.3805L50.6991 16.7244C50.8469 16.8037 50.8372 17.0188 50.6829 17.0845L46.1255 19.0269C46.0636 19.0533 46.0191 19.1091 46.0071 19.1754L45.1267 24.0506C45.0969 24.2157 44.8894 24.273 44.7792 24.1465L41.5235 20.4124C41.4792 20.3616 41.4124 20.3366 41.3457 20.3457L36.437 21.0149C36.2708 21.0376 36.1523 20.8579 36.2384 20.714L38.7838 16.4637C38.8183 16.406 38.8216 16.3347 38.7923 16.2741L36.6389 11.8124C36.566 11.6614 36.7003 11.4931 36.8638 11.5305L41.6925 12.6379C41.7581 12.6529 41.8269 12.634 41.8756 12.5874L45.4534 9.16072Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.129 3.82148C124.18 3.66184 124.393 3.63267 124.486 3.77263L127.216 7.90633C127.253 7.96251 127.316 7.99625 127.384 7.9961L132.338 7.98519C132.506 7.98482 132.599 8.17866 132.495 8.30984L129.407 12.1841C129.365 12.2367 129.352 12.307 129.373 12.3709L130.915 17.0792C130.967 17.2386 130.811 17.3876 130.654 17.3287L126.016 15.5894C125.953 15.5658 125.882 15.5754 125.827 15.6151L121.826 18.5359C121.69 18.6348 121.501 18.533 121.508 18.3654L121.729 13.4162C121.732 13.349 121.701 13.2847 121.646 13.2453L117.632 10.3422C117.496 10.2439 117.534 10.032 117.696 9.98733L122.471 8.66786C122.536 8.64992 122.587 8.60054 122.608 8.53647L124.129 3.82148Z",
    fill: "#8E8CEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.004,
    cy: 77.7929,
    rx: 3.75,
    ry: 3.74999,
    transform: "rotate(-12.6516 139.004 77.7929)",
    fill: "#8E8CEE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.75,
    cy: 56.25,
    rx: 3.75,
    ry: 3.75,
    fill: "#B1B0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.511 58.3233C34.8513 57.3452 35.92 56.8282 36.898 57.1685C42.7452 59.2029 48.795 63.7832 53.8976 68.5134C59.0355 73.2763 63.3895 78.3582 65.8474 81.6114C66.4717 82.4376 66.308 83.6135 65.4817 84.2377C64.6555 84.862 63.4797 84.6983 62.8554 83.872C60.5176 80.7779 56.3097 75.8629 51.3482 71.2635C46.3515 66.6315 40.7643 62.4842 35.6657 60.7103C34.6877 60.37 34.1707 59.3013 34.511 58.3233Z",
    fill: "#E6E5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9453 37.8237C56.9453 35.0623 59.1839 32.8237 61.9453 32.8237C80.3824 32.8237 98.8195 32.8239 117.257 32.8238C120.018 32.8237 122.257 35.0623 122.257 37.8238V115.421C122.257 118.182 120.018 120.421 117.257 120.421C98.8195 120.421 80.3824 120.421 61.9453 120.421C59.1839 120.421 56.9453 118.182 56.9453 115.421V37.8237Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9453 32.8237C51.9453 30.0623 54.1839 27.8237 56.9453 27.8237C75.3824 27.8237 93.8195 27.8239 112.257 27.8238C115.018 27.8237 117.257 30.0623 117.257 32.8238V110.421C117.257 113.182 115.018 115.421 112.257 115.421C93.8195 115.421 75.3824 115.421 56.9453 115.421C54.1839 115.421 51.9453 113.182 51.9453 110.421V32.8237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.707,
    y: 54.5391,
    width: 47.7888,
    height: 4.18404,
    rx: 2.09202,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.707,
    y: 66.2231,
    width: 47.7888,
    height: 4.18404,
    rx: 2.09202,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.707,
    y: 77.907,
    width: 47.7888,
    height: 4.18404,
    rx: 2.09202,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.707,
    y: 89.5911,
    width: 47.7888,
    height: 4.18404,
    rx: 2.09202,
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.707,
    y: 37.855,
    width: 25.825,
    height: 4.18404,
    rx: 2.09202,
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 23.9453,
    y: 1.82373,
    width: 126.311,
    height: 148.597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.376471 0 0 0 0 0.635294 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.e9386c33312b418e5c03eccd14671403.svg";
export { ForwardRef as ReactComponent };